import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import langReducer from './reducers/headerSlice';
import cacheReducer from './reducers/cacheReducer';
import countryReducer from './reducers/countryReducer';
import menuReducer from './reducers/menuReducer';
import cartReducer from './reducers/cartReducer';
import noticeReducer from './reducers/noticeReducer';
import companyReducer from './reducers/companyReducer';
import planReducer from './reducers/planReducer';
import searchReducer from './reducers/searchReducer';
// import classifyAndCountryReducer from './reducers/classifyAndCountryReducer';
export const store = configureStore({
  reducer: {
    lang: langReducer,
    cache: cacheReducer, // translate
    country: countryReducer, // country
    menus: menuReducer, // menus
    cart: cartReducer, // cart
    notice: noticeReducer, // notice
    company: companyReducer, // notice
    plan: planReducer, // plan
    search: searchReducer,
    // classifyandcountry: classifyAndCountryReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      //关闭序列化状态检测中间件
      serializableCheck: false
    }),
  devTools: true
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
